import { getAccount } from '@/services/webApi';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export default function useAccountQuery({
  enabled
}: { enabled?: boolean } = {}) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) {
      queryClient.removeQueries({ queryKey: ['account'] });
    }
  }, [enabled, queryClient]);

  return useQuery({
    enabled: enabled ?? true,
    queryKey: ['account'],
    retry: false,
    queryFn: getAccount,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false
  });
}
